import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useScreenSize from "@hooks/useScreenSize";
import cn from "classnames";
import { useCallback, useLayoutEffect, useMemo, useRef, useState } from "react";
const ContentTab = (props) => {
    var _a, _b;
    const { contentTabItems, contentTabClassName, useRichTextContent = false, ...rest } = props;
    /**
     * Adding condition that if `isOpen` property is missing in some items,
     * we add that property to items manually and set first item as open
     */
    const tabItems = useMemo(() => {
        const isOpenMissing = contentTabItems.some((item) => typeof item.isOpen === "undefined");
        if (isOpenMissing) {
            return contentTabItems.map((item, index) => ({ ...item, isOpen: index === 0 }));
        }
        return contentTabItems;
    }, [contentTabItems]);
    const sectionRef = useRef();
    const [isWidthOccupied, setIsWidthOccupied] = useState(false);
    const [accordion, setAccordion] = useState(tabItems);
    const screenResize = useScreenSize();
    const activeTab = useMemo(() => {
        return accordion.filter((item) => item.isOpen)[0];
    }, [accordion]);
    const toggleAccordion = useCallback((index) => {
        setAccordion(contentTabItems.map((tabItem, idx) => ({ ...tabItem, isOpen: idx === index })));
    }, [accordion]);
    useLayoutEffect(() => {
        const totalWidth = Array.from(sectionRef.current.children).reduce((total, tabItem) => total + tabItem.getBoundingClientRect().width, 0);
        const sectionWidth = sectionRef.current.getBoundingClientRect().width;
        setIsWidthOccupied(totalWidth > sectionWidth);
    }, [sectionRef, screenResize]);
    return (_jsxs("div", { ...rest, children: [_jsx("section", { ref: sectionRef, role: "tablist", className: cn("content-tab__tabs-container", { "justify-center": !isWidthOccupied, "justify-start": isWidthOccupied }, contentTabClassName), children: accordion.map((tabItem, index) => (_jsx("button", { role: "tab", className: cn("content-tab__tab-item", { "bg-slate-transparent": tabItem.isOpen }), onClick: () => toggleAccordion(index), children: tabItem.title }, `${tabItem.title}-${index}`))) }), _jsx("section", { className: "content-tab__content-container", children: useRichTextContent ? (_jsx("div", { className: "content-tab__content content-tab__content--rich-text", dangerouslySetInnerHTML: { __html: ((_a = activeTab === null || activeTab === void 0 ? void 0 : activeTab.content) !== null && _a !== void 0 ? _a : "") } })) : (_jsx("div", { className: "content-tab__content", children: (_b = activeTab === null || activeTab === void 0 ? void 0 : activeTab.content) !== null && _b !== void 0 ? _b : "" })) })] }));
};
export default ContentTab;
